<template>
	<div>
		<item-list :type="1"/>
		<!-- <div style="height: 3rem;"></div> -->
	</div>
</template>
<script>
	import ItemList from '../components/ShizhengItemList'

	export default{
		created(){
			
		},
		components: {
			ItemList
		}
	}
</script>